import { render, staticRenderFns } from "./judgementLog.vue?vue&type=template&id=2e3a622b&scoped=true&"
import script from "./judgementLog.vue?vue&type=script&lang=js&"
export * from "./judgementLog.vue?vue&type=script&lang=js&"
import style0 from "./judgementLog.vue?vue&type=style&index=0&id=2e3a622b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a622b",
  null
  
)

export default component.exports